import React, { useEffect, useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import MsgUtils from '../Tools/MsgUtils';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const server = process.env.REACT_APP_SERVER;
const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
            labels: {
                color: 'white',
                fontSize: 15
            }
        },
        title: {
            display: true,
            text: 'Ventas De sucursal',
            color: 'white',
            fontSize: 18,
        }
    },
    scales: {
        y: {
            display: true,
            title: {
                display: true,
                text: 'CANTIDAD',
                color: 'white',
                font: {
                    family: 'Comic Sans MS',
                    size: 20,
                    weight: 'bold',
                    lineHeight: 1.2,
                },
                padding: { top: 20, left: 0, right: 0, bottom: 0 }
            },
            ticks: {
                color: 'white',
                fontSize: 12,
            }
        },
        x: {
            title: {
                display: true,
                text: 'HORAS',
                color: 'white',
                font: {
                    family: 'Comic Sans MS',
                    size: 20,
                    weight: 'bold',
                    lineHeight: 1.2,
                },
                padding: { top: 20, left: 0, right: 0, bottom: 0 }
            },
            ticks: {
                color: 'white',
                fontSize: 12,
            }
        },
    }
};
const coloresSucursal = ['#93C54B', '#5D22E1', '#225DE1', '#22E15D', '#E15D22', '#E1225D', '#05327D', '#B89EF0', '#697576', '#A3A300', '#F8BEE1', '#5F26A6', '#C1ECA7']
function GraficaCantidadVenta(props) {
    const { fecha, sucursales } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        console.log('componente con fecha', fecha);
        var info = JSON.parse(localStorage.getItem('__react_session__'));
        fetch(`${server}/reporte/getCantidadVentas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'regional': info.regional, fecha
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    var datasets = []
                    var labels = [... new Set(data.ok.map((item) => item.HORA).sort((a, b) => a - b))]
                    var cont = 0;
                    for (var tp of sucursales) {
                        var datosFiltrado = data.ok.filter((item) => item.ID_SUCURSAL == tp.ID_SUCURSAL);
                        var valores = []
                        for (var hora of labels) {
                            var dato = datosFiltrado.filter((item) => item.HORA == hora);
                            if (dato.length == 0) {
                                valores.push(0)
                            } else {
                                valores.push(dato[0].CANTIDAD)
                            }
                        }
                        datasets.push({
                            label: tp.SUCURSAL,
                            data: valores,
                            backgroundColor: coloresSucursal[cont],
                            barPercentage: 1.0,
                        })
                        cont += 1
                    }
                    var dataAux = {
                        labels: [...labels],
                        datasets,
                    }
                    setData(dataAux)
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoading(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [fecha])
    return (
        <div>
            {loading == true && <div className='text-center badge-warning'><i className="fa-solid fa-spinner fa-fade fa-spin-pulse fa-2xl text-light"></i></div>}
            {loading == false && data.length != 0 && <Bar options={options} data={data} updateMode='resize' height={600} style={{ color: '#ffffff' }} />}
        </div>
    )
}

export default GraficaCantidadVenta